import { InitConfig } from '@solidgate/react-sdk';

export { FormType as FormTypes } from '@solidgate/react-sdk';

export type PaymentFormParams = Omit<InitConfig, 'merchantData'>;
